import { gql, type OperationVariables } from '@apollo/client';
import type ICompanySettings from '@sharedInterfaces/ICompanySettings';
import type { EEmailTransferOption } from '@sharedInterfaces/ICompanySettings';
import Company from '@src/Objects/Company';

import GraphQL from '../graphQL';

import { companySettingsGql } from './getCompanySettings';

const query = gql`
mutation editEmailTransferOption($state: String!, $mailbox: String) {
    editEmailTransferOption(state: $state, mailbox: $mailbox) 
    ${companySettingsGql}
},
`;

export default async function editEmailTransferOption(state: EEmailTransferOption, mailbox?: string) {
    const variables: OperationVariables = {
        state,
        mailbox,
    };
    return GraphQL.mutate<ICompanySettings>(query, variables).then((c) => new Company(c));
}
